module.exports = __webpack_public_path__ + "img/Apoint4.4b0c75d1.png";